import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { COLORS, SPACING } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(productCardStyles, {
    ...productCardStyles,
    gridContainer: {
        gap: 0,
        css: css`
            padding: 30px 0;
            border: 1px solid ${COLORS.border.base};
            min-width: 320px; /* prevent overlap with second column */
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            padding-right: 20px;
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 9, 9],
    },
    infoGridItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            padding: 0 ${SPACING.standard};
        `,
    },
    actionsGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            padding: 0 ${SPACING.standard} ${SPACING.standard} ${SPACING.standard};
        `,
    },
});
